import * as config from "@/config";
import { postServiceCall, getServiceCall } from "./base";
import {
  DBBranchData,
  BranchSaveRequest,
  Payment,
  PaymentEdit,
  PaymentEditResult,
  PaymentAction,
  PaymentActionResult,
  PaymentData,
  BranchSaveResponse,
  ListPaymentQuery,
  PaymentList
} from "../types";
import { isoDateString } from "@/util";
import { getUserTimeZone } from "@/util/dates_m";
import store from "../store";

export async function paymentGetBranches(companyID: number): Promise<DBBranchData[]> {
  return await postServiceCall("payment/branchGet", { companyID, language: store.state.lang.key });
}

export async function paymentSaveBranch(data: BranchSaveRequest): Promise<BranchSaveResponse> {
  return await postServiceCall("payment/branchSave", { ...data, language: store.state.lang.key });
}

export async function listPayments(data: ListPaymentQuery): Promise<PaymentList> {
  return await postServiceCall("payment/list", { ...data, language: store.state.lang.key });
}

export async function updatePayment(data: PaymentEdit): Promise<PaymentEditResult> {
  return await postServiceCall("payment/update", { ...data, language: store.state.lang.key });
}

export async function paymentAction(data: PaymentAction): Promise<PaymentActionResult> {
  return await postServiceCall("payment/action", { ...data, language: store.state.lang.key });
}

export async function getPayment(paymentID: string): Promise<Payment> {
  return await getServiceCall(`payment/get?key=${paymentID}&admin=true&language=${store.state.lang.key}`);
}

export function makePaymentURL(paymentID: string): string {
  return config.default.paymentLinkURL + "link/" + paymentID;
}

export function newPaymentData(): PaymentData {
  return {
    opType: "sale",
    createPaymentToken: true,
    customerAuthentication: "strong",
    companyID: 0,
    branchID: 0,
    // User Data
    language: "ES",
    userFullName: "",
    userEmail: "",
    changeCard: true,
    userCard: "",
    userExpiration: "",
    // Transaction Data
    expiration: isoDateString(1),
    expirationHours: 0,
    expirationTZ: getUserTimeZone(),
    isTest: false,
    clientID: "",
    amountCents: 0,
    currency: "EUR",
    description: "",
    details: [],
    attachedFiles: [],
    customFormFields: [],
    notifyEmailKo: false
  };
}
